/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import aboutUsSectionStyle from "./aboutUsSectionStyle";
import Typography from "@mui/material/Typography";
import Container from "../../../../components/Container/Container";

const AboutUsSection = () => {
  return (
    <Container>
      <Typography variant={"h2"} sx={aboutUsSectionStyle.centeredText}>
        Unser Versprechen an Sie
      </Typography>
      <Typography variant={"subtitle1"} sx={aboutUsSectionStyle.subtitle}>
        Sie können darauf vertrauen, dass Sie bei uns sicher und zuverlässig zum Ziel gelangen! Wir kümmern uns jederzeit persönlich und professionell um Ihr
        Anliegen, indem wir die Erfahrung aus zehntausenden Mandaten mit neuester Technologie kombinieren. So wird Recht für Sie zugänglich und
        selbstverständlich!
      </Typography>
    </Container>
  );
};

export default AboutUsSection;
